import { Layout, Menu, Breadcrumb } from 'antd';
import { LaptopOutlined, NotificationOutlined, RightCircleFilled } from '@ant-design/icons';
import TopBar from "./TopBar";
import SideBar from "./SideBar";
import {Link} from 'react-router-dom';

const { SubMenu } = Menu;
const { Header, Content, Sider } = Layout;

export default function LayoutComponent({title, links,children, newButton, subTitle}){

    return (
        <Layout className="layout">
            <Header className="header">
              <TopBar/>
            </Header>
            <Layout>
                <SideBar/>
                <Layout style={{ padding: '0 24px 24px' }}>
                    <Breadcrumb style={{ margin: '16px 0' }}>
                        <Breadcrumb.Item >
                            <Link to="/">
                            Anasayfa
                            </Link>
                        </Breadcrumb.Item>
                        {links && links.map((item, idx) => (
                            <Breadcrumb.Item key={idx}>
                                <Link to={item.url}>
                                    {item.title}
                                </Link>
                            </Breadcrumb.Item>
                        ))}
                    </Breadcrumb>

                    <Content
                        className="site-layout-background"
                        style={{
                            padding: 10,
                            margin: 0,
                        }}
                    >
                        <div className="page-header">
                            <h1 style={{fontSize: '25px', marginBottom: 0}}>{title}</h1>
                            {newButton}
                        </div>
                        {subTitle && (
                            <div>
                                <p>{subTitle}</p>
                            </div>
                        )}

                        {children}
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    )
}
